
import { Component, Mixins } from "vue-property-decorator";
import { Profession } from "../../../../domain/user";
import { SelectorDialogMixin } from "../../../system/dialogs/mixins";
import { IMultiSelectableAsynchronously, IMultiSelectableConditionallyAsynchronously } from "../../../system/selectors";
import { IProfessionListSelectorDialogCondition, IMultiProfessionListSelectorDialogCondition, } from "../";

@Component
export default class MultiOrderableProfessionListSelectorDialogMixin extends Mixins(SelectorDialogMixin) implements IMultiSelectableAsynchronously<Profession>, IMultiSelectableConditionallyAsynchronously<Profession, IProfessionListSelectorDialogCondition> {
  data(): any {
    return {
      title: "職種",
    };
  }
  title: string;

  async selectOptions(defaultOptions?: Profession[]): Promise<Profession[]> {
    return this.show<Profession[]>(defaultOptions);
  }

  async selectOptionsConditionally(condition: IMultiProfessionListSelectorDialogCondition, defaultOption?: Profession[]): Promise<Profession[]> {
    return this.show<Profession[]>(defaultOption);
  }
}
